import { getSupabase } from '../supabaseClient';

export type SyncRow = Record<string, string | number | boolean | null>;
export type SyncResource = 'todos' | 'todo_tag_map' | 'todo_stock_items';

export class TodoSyncConflictError extends Error {
  constructor(
    public resource: SyncResource,
    public key: SyncRow,
    public base: SyncRow | null,
    public changes: SyncRow,
    public remote: SyncRow | null,
    public fields: string[],
  ) {
    super('別の編集と競合しています。入力はこの画面に保持しています。');
    this.name = 'TodoSyncConflictError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export async function syncTodoChange(resource: SyncResource, key: SyncRow, base: SyncRow | null, changes: SyncRow): Promise<SyncRow> {
  const { data, error } = await getSupabase().rpc('sync_todo_change', {
    p_resource: resource, p_key: key, p_base: base, p_changes: changes, p_request_id: crypto.randomUUID(),
  });
  if (error) throw error;
  if (data?.status === 'conflict') {
    throw new TodoSyncConflictError(resource, key, base, changes, data.row, data.fields);
  }
  if (data?.status !== 'saved' || !data.row) throw new Error('保存結果を確認できませんでした。入力を保持して再試行してください。');
  return data.row;
}
